import { cloneObject } from '../../../../utils';
import { getFields } from '../../../../utils/defaultFields';

const fields = [
    'address',
    'addressNumber',
    'admissionDate',
    'birth',
    'capacity',
    'cardNumber',
    'cellphone',
    'cep',
    'cid',
    'city',
    'civilState',
    'company',
    'complement',
    'contractName',
    'costCenter',
    'countyService',
    'contractSize',
    'contractType',
    'cpf',
    'dateStartPlan',
    'lackGroup',
    'dn',
    'email',
    'enrollmentSequence',
    'fullName',
    'functionalEnrollment',
    'functionalStatus',
    'gender',
    'healthPlan',
    'height',
    'hood',
    'motherName',
    'nationality',
    'occupation',
    'pis',
    'socialName',
    'startCapacity',
    'startDate',
    'stateService',
    'sus',
    'uf',
    'weight',
    'congenerName',
];

const schema = {
    ...cloneObject(getFields(fields)),
    countyService: {
        ...cloneObject(getFields(['countyService'])).countyService,
        required: false
    }
};

schema.documents = [];
schema.motherName.requiredMessage = 'Informe o nome da mãe da pessoa titular';
schema.fullName.requiredMessage = 'Adicione o nome e o sobrenome da pessoa titular';
schema.dn.requiredMessage = 'Adicione a declaração de nascido vivo da pessoa titular';

export default schema;
